import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "wrapper", "track", "knob"]

  connect () {
    this.sync()
  }

  toggle () {
    this.sync()
  }

  sync () {
    if (!this.hasCheckboxTarget) return

    const on = this.checkboxTarget.checked

    this.checkboxTarget.setAttribute("aria-checked", String(on))

    if (this.hasWrapperTarget) {
      this.wrapperTarget.classList.toggle("hidden", !on)
    }

    if (this.hasTrackTarget) {
      this.trackTarget.classList.toggle("bg-success", on)
      this.trackTarget.classList.toggle("bg-primary-light-color/40", !on)
    }

    if (this.hasKnobTarget) {
      this.knobTarget.classList.toggle("translate-x-5", on)
      this.knobTarget.classList.toggle("translate-x-0", !on)
    }
  }
}
